// eslint-disable-next-line import/prefer-default-export
export const ALLOWED_PROVISIONING_ROUTES = [
  '/apxreports',
  '/order',
  '/vtickets',
];
